import React from 'react';
import './Pokerwatch_new.css';
import Loading from '../Loading.js';
// Import React Table
import "../../css/react-table-custom.css";
import 'moment-timezone';
import moment from 'moment';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage , saveActivity} from '../../common/commonService';
import { apiService } from '../../common/apiCallService.js';
import { baseUrl } from '../../common/config.js';
import CustomisedDialog from './CustomisedDialog';
import {CreateUser,EditUser,CreateTeam,
  UserEditDiv,CreateOwner,Role,ChangeRole,LoginTrackingHistory, CustomMobileModal} from './pokerwatchCommonComponents';
var _ = require('lodash');

import PokerWatchAdmin from './pokerwatch_admin';

class PokerWatchNew extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      offset: 0,
      toDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      fromDate: moment(new Date()).subtract(2, 'days').format("YYYY-MM-DD HH:mm:ss"),
      fTime: moment().format("HH:mm:ss"),
      tTime: moment().format("HH:mm:ss"),
      open: false,
      max: 10,
      sortBy: 'asc',
      activePage: 1,
      currColumn: 'profitOrLoss',
      loginRedirect: false,
      loading: true,
      title: 'Poker Watch New',
      sortOn: 'lastHandPlayer',
      maxCount: 20,
      data: [],
      createTeamModal: false,
      newTeamName: '',
      deleteTeamModal: false,
      deleteTeamData: [],
      
      items: [],
      checked: true,
      query: '',
      searchFunc: false,
      teamNameData: [],
      teamErrorMessage: '',
      pokerwatchConfigObj: {},
      creatTeamObj: {},
      isTeamAlreadyExist: false,
      isOwnerAlreadyExist: false,
      dialogContent: { 'isDialogOpen': false },

    };
    this.routeChange = this.routeChange.bind(this);
  }

  callApi = (sortOnField, sortBy) => {
    this.setState({
      loading: true,
      searchFunc: false
    })
    apiService(baseUrl + '/pokerWatch/getTeamList',
      {
        page:'pokerwatch',
        orderBy: sortBy,
        sortOn: sortOnField,
        startDate: this.state.fromDate,
        endDate: this.state.toDate,
        offset: this.state.offset
      }
      ,
      (data) => {
      const {pokerwatchConfigObj} = this.state;
       pokerwatchConfigObj['creatTeamObj'] = {}
      pokerwatchConfigObj['selectedTeams'] = [];
      pokerwatchConfigObj['data']=data;
        this.setState({
          data: data,
          pokerwatchConfigObj,
          loading: false,
        })
      }, (err) => {
        this.setState({
          loading: false,
        })
        console.log(err);
      })

  }
  componentWillMount () {
    this.props.setHeaderTitle(this.state.title);
  }
  enableUserPropDiv = (e,data,index) => {
    const {pokerwatchConfigObj} = this.state;
    let enableUserProp = pokerwatchConfigObj['enableUserProp'] || {};
   

      enableUserProp['status'] = !enableUserProp['status']
      enableUserProp['row']=data;
   
      enableUserProp['index']=index;
      enableUserProp['component']=<UserEditDiv {...this.state.pokerwatchConfigObj}></UserEditDiv>;
      pokerwatchConfigObj['userData']= [data];
      pokerwatchConfigObj['createTeamObj']={}; 
    pokerwatchConfigObj['enableUserProp'] = enableUserProp;
    this.setState({
      pokerwatchConfigObj
    })
  }

  getUserDiretory = (sortBy,sortOnField) => {
    this.setState({
      loading: true,
      searchFunc: false
    })
    apiService(baseUrl + '/pokerWatch/getUsersTracking',
      {
        orderBy: sortBy,
        sortOn: sortOnField,
      }
      ,
      (data) => {
      const {pokerwatchConfigObj} = this.state;
      //  pokerwatchConfigObj['creatTeamObj'] = {}
      // pokerwatchConfigObj['selectedTeams'] = [];
      let ROLES = {
        'SYS_ADMIN':'Admin',
        'COACH':'Coach',
        'BUSINESS_OWNER':'Stable Owner'
      }
      let playerStats = data && data.map((item, key) => {

        item['show_role'] = ROLES[item.role]
        item['more'] = <i className="fa fa-lg fa-ellipsis-h pw-more-enable-icon" style={{color:'#E8490D'}}></i>
        return item
      })
      pokerwatchConfigObj['data']=playerStats;
      delete pokerwatchConfigObj['displayResults'];
        this.setState({
          data: data,
          pokerwatchConfigObj,
          loading: false,
        })
      }, (err) => {
        this.setState({
          loading: false,
        })
        console.log(err);
      })
  }
  componentDidMount() {
    const { pokerwatchConfigObj, dialogContent } = this.state;
    pokerwatchConfigObj['handleTimeZone'] = this.handleTimeZone;
    pokerwatchConfigObj['routeChange'] = this.routeChange;
    pokerwatchConfigObj['handleCheckbox']=this.handleCheckbox;
    pokerwatchConfigObj['handleCheck']=this.handleCheck;
    pokerwatchConfigObj['selectedTeams'] = [];
    pokerwatchConfigObj['handleSort'] = this.sorting;
    pokerwatchConfigObj['handleChange'] = this.handleChange;
    pokerwatchConfigObj['handleInputChange'] = this.handleInputChange;
    pokerwatchConfigObj['handleRoleChange']=this.handleRoleChange;
    pokerwatchConfigObj['openDialogBox'] = this.openDialogBox;
    pokerwatchConfigObj['cancelDialog'] = this.cancelDialog;
    pokerwatchConfigObj['dialogContent'] = dialogContent;
    pokerwatchConfigObj['action'] = this.routeChange;
    pokerwatchConfigObj['searchHandler'] = this.searchHandler;
    pokerwatchConfigObj['teamNameData'] = [];
    pokerwatchConfigObj['isTeamAlreadyExist'] = this.state.isTeamAlreadyExist;
    pokerwatchConfigObj['isOwnerAlreadyExist'] = this.state.isOwnerAlreadyExist;
    pokerwatchConfigObj['verifyUnique'] = this.verifyUnique;
    pokerwatchConfigObj['creatTeamObj'] = {};
    pokerwatchConfigObj['createTeam'] = this.createTeam;
    pokerwatchConfigObj['errorOBj'] = {};
    pokerwatchConfigObj['updateObject']=this.updateObject;
    pokerwatchConfigObj['data']=[];
    pokerwatchConfigObj['ownerNameData'] = [];
    pokerwatchConfigObj['NumberFormatter']=this.NumberFormatter;
    pokerwatchConfigObj['toggleUserDirectory']=this.toggleUserDirectory;
    pokerwatchConfigObj['handleUserDirectory']=this.handleUserDirectory;
    pokerwatchConfigObj['enableUserPropDiv'] = this.enableUserPropDiv;
    pokerwatchConfigObj['handleUserProps']=this.handleUserProps;
    pokerwatchConfigObj['verifyUserEmailOrAccountName']=this.verifyUserEmailOrAccountName;
    pokerwatchConfigObj['enablePasswordEdit']=this.enablePasswordEdit;
    this.setState({
      pokerwatchConfigObj
    });

    this.callApi(this.state.sortOn, this.state.sortBy);

  }
  enablePasswordEdit = (event) => {
    const {pokerwatchConfigObj} = this.state;
    let {creatTeamObj} = pokerwatchConfigObj;
    creatTeamObj[[event]] = !creatTeamObj[[event]];
    pokerwatchConfigObj['createTeamObj']=creatTeamObj;
    this.setState({
      pokerwatchConfigObj
    })
  }

  handleTimeZone = (event, index, value) => {
    this.setState({
      timeValue: "Select",
      shiftValue: "Select",
      timeZonevalue: value
    });
    this.state.timeZone = value
    this.state.searchTime.shift = "Select"
  }
  routeChange = (event, teamData) => {
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'StableSelect';
    track.hit_attribute1 = teamData.teamName || teamData.name;
    saveActivity(track);
    teamData['teamName'] = teamData.teamName != undefined ? teamData.teamName : teamData.name;
    let obj = {
      'name':teamData.teamName ,
      'ownerName':teamData.ownerName
    }
    let path = '/pokerwatchteam';
    this.props.history.push(path, { teamData: teamData });
   // localStorage.setItem (JSON.stringify(teamData))
    localStorage.setItem('teamData', JSON.stringify(obj));
  }
  compare = (a, b) => {
    // Use toUpperCase() to ignore character casing
    
    const bandA = a._id.toUpperCase();
    const bandB = b._id.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }
  
  sorting = (event, column) => {

    const {pokerwatchConfigObj} = this.state;
    let {enableUserDirectory,displayResults,data} = pokerwatchConfigObj;
    if(enableUserDirectory) {
      // console.log('sortBy',this.state.sortBy);
      if(this.state.sortBy === 'desc') {
    
        data.sort(this.compare);
      }
      else {
        data.sort(this.compare);
        data.reverse();
      }
      pokerwatchConfigObj['data']=data;
      this.setState({
        pokerwatchConfigObj,
        sortOn: column,
        sortBy: this.state.sortBy == 'asc' ? 'desc' : 'asc'
      });
    }
    else {
    this.callApi(column, this.state.sortBy == 'asc' ? 'desc' : 'asc');
    this.setState({
      sortOn: column,
      sortBy: this.state.sortBy == 'asc' ? 'desc' : 'asc'
    });
    }
   

  }
  handleChange = (data, dateType) => {

    this.setState({
      [dateType]: data
    })
  }
  openModal = () => {
    this.setState({
      createTeamModal: !this.state.createTeamModal,
      searchFunc: false

    })
  }
  openDelete = () => {
    if (this.state.deleteTeamData.length > 0) {
      this.setState({
        deleteTeamModal: true
      })
    }

  }
 
handleCheck = (item) => {
  const {pokerwatchConfigObj} = this.state;
  let {enableUserDirectory} = pokerwatchConfigObj;
  let selectedTeamData  = pokerwatchConfigObj[enableUserDirectory?'userData':'selectedTeams'] ?  pokerwatchConfigObj[enableUserDirectory?'userData':'selectedTeams']:[];
  const index = selectedTeamData.indexOf(item);
  if (index > -1) {
     
    selectedTeamData.splice(index, 1);
    
  } else {
   // this.handleSelect(item.name)
    selectedTeamData.push(item);
  }
  pokerwatchConfigObj[enableUserDirectory?'userData':'selectedTeams'] = selectedTeamData;
  this.setState({
    pokerwatchConfigObj
  })
}
  handleCheckbox = (seletedData) => {
    const {pokerwatchConfigObj} = this.state;

     let {enableUserDirectory} = pokerwatchConfigObj;
     if(enableUserDirectory) {
           pokerwatchConfigObj['userData']=seletedData;
    }else {
      pokerwatchConfigObj['selectedTeams']= seletedData
    }
    let enableUserProp = pokerwatchConfigObj['enableUserProp'] || {};
   
    if (enableUserProp &&  enableUserProp.status) {
      enableUserProp['status'] = false;
      enableUserProp['row'] = {};
      enableUserProp['index'] = -1;
      enableUserProp['component'] = null;
      pokerwatchConfigObj['enableUserProp'] = enableUserProp;
    }
      this.setState({
        pokerwatchConfigObj
      })
   
   
  }
  callApiService = (endPoint, data) => {
    apiService(baseUrl + endPoint,
      data,
      (data) => {
        const { pokerwatchConfigObj, dialogContent } = this.state;
        dialogContent['cancelDialog'] = this.cancelDialog;
          dialogContent['isDialogOpen'] = true;
        if (endPoint =='/pokerWatch/createOwner') {
          dialogContent['dataType'] = 'createTeamModal';
          dialogContent['actionPerform'] = this.createTeam;
          
          dialogContent['objectType'] = 'team';
        }
        else if(
          endPoint =='/pokerWatch/changeUserRole'||
          endPoint =='/pokerWatch/updateUserDetails'
         || endPoint =='/pokerWatch/deleteUser' || endPoint =='/pokerWatch/createUser'){
          const {enableUserProp} = pokerwatchConfigObj;
          if(enableUserProp &&  enableUserProp.status) {
          enableUserProp['status'] = !enableUserProp['status'];
          enableUserProp['row']={};
          enableUserProp['index']=-1;
          pokerwatchConfigObj['enableUserProp']=enableUserProp
          }
          dialogContent['isDialogOpen'] = false;
          dialogContent['dataType'] = 'editUser';
          pokerwatchConfigObj['userData']=[];
          this.getUserDiretory()
        }
        else if(endPoint === '/pokerWatch/getLoginHistory') {
          pokerwatchConfigObj['userHistory'] = data;
          // dialogContent['isDialogOpen'] = false;
          // dialogContent['dataType'] = 'viewHistory';
        }
        else{
          this.callApi(this.state.sortOn, this.state.sortBy);
          dialogContent['isDialogOpen'] = false;
          dialogContent['dataType'] = 'deleteTeamModal';
          dialogContent['actionPerform'] = this.deleteTeamList;

        }
        pokerwatchConfigObj['dialogContent'] = dialogContent;
        pokerwatchConfigObj['isOwnerAlreadyExist'] = false;
        this.setState({
          pokerwatchConfigObj,
          deleteTeamData: [],
          checked: false,
        })
      }, (err) => {

        if (endPoint == '/pokerWatch/createTeam' || '/pokerWatch/createOwner' || '/pokerWatch/updateUserDetails') {
          const { pokerwatchConfigObj } = this.state;
          pokerwatchConfigObj['isOwnerAlreadyExist'] = false;
          pokerwatchConfigObj['errorOBj'] = { 'createTeamError': err.responseJSON.err }
          this.setState({ teamErrorMessage: err.responseJSON.err })
        }
    
        console.log(err);
      })
  }
  createOwner =()=>{
    const { pokerwatchConfigObj } = this.state
    this.callApiService('/pokerWatch/createOwner', pokerwatchConfigObj['creatTeamObj']);
  }
  createTeam = () => {
    const { pokerwatchConfigObj } = this.state
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'CreateNewTeam';
    track.hit_attribute1 = this.state.newTeamName;
    saveActivity(track);
   
    this.callApiService('/pokerWatch/createTeam', pokerwatchConfigObj['creatTeamObj']);
  }

  searchTeam = (event) => {
    var updatedList = this.state.data;
    updatedList = updatedList.filter(function (item) {
      return item.teamName.toLowerCase().search(
        event.target.value.toLowerCase()) !== -1;
    });
    this.setState({ items: updatedList });
  }
  deleteTeamList = () => {
    const {pokerwatchConfigObj} = this.state;
    const selectedData = pokerwatchConfigObj['selectedTeams']
    let selectedTeams = [];
    if (selectedData) {
      selectedTeams = selectedData.map((item, key) => item.name)
    }
    let requestObj = {
      'teamNameList' : selectedTeams
    }
    let track = {}
    track.hit_page = 'Stable';
    track.hit_type = 'DeleteTeam';
    track.hit_attribute1 = this.state.deleteTeamData.join();
    saveActivity(track);

    this.callApiService('/pokerWatch/delteTeamsByIds', requestObj);
  }

  NumberFormatter = (num) => {
    if (isNaN(num)) {
      return 0;
    }
    if (Math.abs(num) > 999 && Math.abs(num) <= 999999) {
      return Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + ' K'
    }
    else if (Math.abs(num) > 999999 && Math.abs(num) <= 999999999) {
      return Math.trunc(Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1))) + ' M'
    }
    else if (Math.abs(num) > 999999999) {
      return Math.sign(num) * ((Math.abs(num) / 1000000).toFixed(1)) + 'B'
    }
    else {
      // return Math.sign(num) * Math.abs(num) > 1 ? Math.trunc(Math.sign(num) * Math.abs(num)) : Math.sign(num) * Math.abs(num);
      // return Number((Math.sign(num) * Math.abs(num) > 1 ? Math.trunc(Math.sign(num) * Math.abs(num)) : Math.sign(num) * Math.abs(num)).toFixed(2));
      return Number(Math.sign(num) * Math.abs(num).toFixed(2));
    }

  }

  verifyUnique = (e, verifyType) => {
    if (e.target.value && e.target.value.length < 2) {
      return;
    }
    else {
      const name = e.target.value;
      const endPoint = verifyType == 'stableName' ? '/pokerWatch/verifyTeamName' : '/pokerWatch/verifyOwnerName';
      apiService(baseUrl + endPoint,
        {
          name: name
        }, (data) => {
          let creatTeamObj = {}
          if (data.length == 0) {
            creatTeamObj['stableName'] = name;
          }
          let { isOwnerAlreadyExist, isTeamAlreadyExist } = this.state;
          const { pokerwatchConfigObj } = this.state;
          pokerwatchConfigObj['creatTeamObj'] = { ...pokerwatchConfigObj['creatTeamObj'], ...creatTeamObj };
          if (data.length > 0) {
            if (verifyType == 'stableName') {
              pokerwatchConfigObj['isTeamAlreadyExist'] = true
              isTeamAlreadyExist = true;
            }
            else {
              pokerwatchConfigObj['isOwnerAlreadyExist'] = true
              isOwnerAlreadyExist = true
            }
          }
          else {
            pokerwatchConfigObj['isTeamAlreadyExist'] = false
            isTeamAlreadyExist = false;
            pokerwatchConfigObj['isOwnerAlreadyExist'] = false
            isOwnerAlreadyExist = false
          }
          this.verifyRequiredParamsForDialog('createTeamModal')
          this.setState({
            creatTeamObj,
            pokerwatchConfigObj,
            isTeamAlreadyExist,
            isOwnerAlreadyExist
          })
        }, (err) => {
          console.log(err);
        })
    }
  }
  
  addInputObject = (e, obj) => {
    const { pokerwatchConfigObj } = this.state

    pokerwatchConfigObj['ownerNameData'] = [];
    pokerwatchConfigObj['creatTeamObj'] = { ...pokerwatchConfigObj['creatTeamObj'], ...obj };
    this.setState({
      pokerwatchConfigObj
    })
    this.verifyRequiredParamsForDialog()
  }
  cancelDialog = (event, modal) => {
    const { pokerwatchConfigObj, dialogContent } = this.state
    if (modal.dataType === 'ownerCreationModal') {
      dialogContent['objectType'] = 'team';
      dialogContent['dataType'] = 'createTeamModal';
      pokerwatchConfigObj['dialogContent'] = dialogContent;
      this.setState({
        pokerwatchConfigObj
      })
    }
    else {
      const { dialogContent, pokerwatchConfigObj } = this.state
      dialogContent['isDialogOpen'] = false;
      pokerwatchConfigObj['dialogContent'] = dialogContent;
      pokerwatchConfigObj['ownerNameData']=[];
      pokerwatchConfigObj['creatTeamObj'] = {}
      this.setState({
        pokerwatchConfigObj,
        dialogContent
      })
    }
  }
  createUser = () => {
    const { pokerwatchConfigObj } = this.state
    const {creatTeamObj,enableUserProp} = pokerwatchConfigObj;
 
    this.callApiService('/pokerWatch/createUser', creatTeamObj);
  }
  updateUserDetails = () => {
    const { pokerwatchConfigObj } = this.state
    const {creatTeamObj,enableUserProp} = pokerwatchConfigObj;
    creatTeamObj['userId']=enableUserProp.row.userId;
    this.callApiService('/pokerWatch/updateUserDetails', creatTeamObj);
  }
  changeUserRole = ()=> {
    const { pokerwatchConfigObj } = this.state
    const {creatTeamObj,enableUserProp} = pokerwatchConfigObj;
    creatTeamObj['userId']=enableUserProp.row.userId;
    creatTeamObj['currentUserRole']= enableUserProp.row.role;
    this.callApiService('/pokerWatch/changeUserRole', creatTeamObj);
  }
  searchHandler =(event) =>{
    let searcjQery = event.target.value.toLowerCase();
    const {pokerwatchConfigObj} = this.state;
    const data = pokerwatchConfigObj['data']
    let displayResults = data.filter((el) => {
        let searchValue = el._id.toLowerCase();
        return searchValue.indexOf(searcjQery) !== -1;
      })
      
    pokerwatchConfigObj['displayResults']= displayResults;
    let enableUserProp = pokerwatchConfigObj['enableUserProp'] || {};
   
    if (enableUserProp &&  enableUserProp.status) {
      enableUserProp['status'] = false;
      enableUserProp['row'] = {};
      enableUserProp['index'] = -1;
      enableUserProp['component'] = null;
      pokerwatchConfigObj['enableUserProp'] = enableUserProp;
    }
    this.setState({
      pokerwatchConfigObj
    })
    }
  deleteUserDetails = () => {
    const { pokerwatchConfigObj } = this.state
    const selectedData = pokerwatchConfigObj['userData']
    let userIds = [];
    if (selectedData) {
      userIds = selectedData.map((item, key) => item.userId)
    }
    let requestObj = {
      'userIds' : userIds
    }
    this.callApiService('/pokerWatch/deleteUser', requestObj);
  }
  getLoginIPHistory = () => {
    const { pokerwatchConfigObj } = this.state
    const {creatTeamObj,enableUserProp} = pokerwatchConfigObj;
    creatTeamObj['userId']=enableUserProp.row.userId;
    this.callApiService('/pokerWatch/getLoginHistory', creatTeamObj);
  }
  openDialogBox = (dataType) => {
    let customStyle = {
      width: window.innerWidth <= 1024 ? '28.8rem' : '38.5rem', top: window.innerWidth <= 1024 ? '3%' : '-8%',
      left: window.innerWidth <= 320 ? '-2rem' : window.innerWidth <= 375 ? '0px' : window.innerWidth <= 425 ? '30px' : window.innerWidth <= 768 ? '26%' : window.innerWidth <= 1024 ? '20%' : window.innerWidth <= 1440 ? '30%' : '36%', height: '10%',
      borderRadius:'4px'
    };
    const { dialogContent, pokerwatchConfigObj } = this.state
    pokerwatchConfigObj['creatTeamObj']={};
    dialogContent['width'] =customStyle.width;
    dialogContent['height'] = '30.9rem';
    dialogContent['createButtonLable'] = 'Create';
    dialogContent['padding']='0px 20px 20px 20px';
    dialogContent['createButtonStyleName'] = 'poker-watch-create-team-button-not-active';
    dialogContent['isButtonsShow']=true;
    if(dataType === 'deleteTeamModal' ) {
      dialogContent['createButtonStyleName']='poker-watch-create-team-button'
      dialogContent['dataType'] = 'deleteTeamModal';
      dialogContent['title'] = 'Delete Stable';
      dialogContent['actionPerform'] = this.deleteTeamList;
      dialogContent['width'] = window.innerWidth <= 1024 ?window.innerWidth<=768?'28.8rem':'37rem':'51.1rem';
      dialogContent['createButtonLable'] = 'Delete';
    }
    else if (dataType === 'editUser') {
      
      dialogContent['dataType'] = 'editUser';
      dialogContent['title'] = 'Edit Details';
      
      dialogContent['actionPerform'] = this.updateUserDetails;
      dialogContent['createButtonLable'] = 'Change';
    }
    else if (dataType === 'changeRole') {
      dialogContent['dataType'] = 'changeRole';
      dialogContent['title'] = 'Change Role';
    
      dialogContent['actionPerform'] = this.changeUserRole;
      dialogContent['createButtonLable'] = 'Change';
    }
    else if (dataType === 'deleteUser') {
      dialogContent['createButtonStyleName']='poker-watch-create-team-button'
      dialogContent['dataType'] = 'deleteUser';
      dialogContent['title'] = 'Delete User';
      dialogContent['width'] = window.innerWidth <= 1024 ?window.innerWidth<=768?'28.8rem':'37rem':'51.1rem';
    
      dialogContent['actionPerform'] = this.deleteUserDetails;
      dialogContent['createButtonLable'] = 'Delete';
    }
    else if(dataType === 'viewHistory') {
      dialogContent['dataType'] = 'viewHistory';
      dialogContent['title'] = 'Log in & IP History';
      dialogContent['isButtonsShow']=false;
      dialogContent['height']='34.1rem'
      this.getLoginIPHistory();
    }
    else if(dataType === 'createUser') {
      dialogContent['dataType'] = 'createUser';
      dialogContent['objectType'] = 'createUser';
      dialogContent['actionPerform']=this.createUser;
      dialogContent['title'] = 'Create new user'
      let enableUserProp = pokerwatchConfigObj['enableUserProp'] || {};
   
      if (enableUserProp &&  enableUserProp.status) {
        enableUserProp['status'] = false;
        enableUserProp['row'] = {};
        enableUserProp['index'] = -1;
        enableUserProp['component'] = null;
        pokerwatchConfigObj['enableUserProp'] = enableUserProp;
      }
    }
    else {
      dialogContent['title'] = 'Create Stable';
      dialogContent['dataType'] = 'createTeamModal';
      dialogContent['actionPerform'] = this.createTeam;
    }
    ;
    dialogContent['fontSize'] = '25px';
   
   
    dialogContent['customStyle'] = customStyle;
  
    dialogContent['cancelDialog'] = this.cancelDialog;
    dialogContent['isDialogOpen'] = true;
    dialogContent['objectType'] = 'team';
    dialogContent['errorMessage'] = '';
    pokerwatchConfigObj['errorOBj']='';
    pokerwatchConfigObj['dialogContent'] = dialogContent;
    this.setState({
      dialogContent,
      pokerwatchConfigObj
    })
  }
  updateObject = (data) => {
    const {pokerwatchConfigObj, dialogContent } = this.state
    dialogContent['dataType'] = 'ownerCreationModal';
    dialogContent['objectType'] = 'ownerCreationModal';
    dialogContent['actionPerform']=this.createOwner;
    dialogContent['title'] = 'Create Stable Owner'
    pokerwatchConfigObj['dialogContent']=dialogContent;
    this.setState({
        pokerwatchConfigObj
    })
}
verifyRequiredParamsForDialog = (custom) => {
  const {pokerwatchConfigObj,dialogContent}=this.state;
  let type =custom?custom: dialogContent['dataType'];
 
  let createTeamObj =  pokerwatchConfigObj['creatTeamObj'] ;
  dialogContent['createButtonStyleName']='poker-watch-create-team-button-not-active'
  switch (type) {
      case 'custom':
        dialogContent['createButtonStyleName']='poker-watch-create-team-button-not-active'
        break;
      case 'ownerCreationModal':
        if(createTeamObj.fullName && createTeamObj.email && createTeamObj.password){
          dialogContent['createButtonStyleName']='poker-watch-create-team-button'
        }
        break;
      case 'createTeamModal':
        if(createTeamObj.name && createTeamObj.stableName){
          dialogContent['createButtonStyleName']='poker-watch-create-team-button'
        }
      case 'editUser':
        if(createTeamObj.email || createTeamObj.password || createTeamObj.fullName){
          dialogContent['createButtonStyleName']='poker-watch-create-team-button'
        }
        break;
      case 'changeRole':
        if(createTeamObj.roleValue){
          dialogContent['createButtonStyleName']='poker-watch-create-team-button'
        }
        break;
      case 'createUser':
        if(createTeamObj.email && createTeamObj.password && createTeamObj.fullName && createTeamObj.roleValue){
          dialogContent['createButtonStyleName']='poker-watch-create-team-button'
        }
        break;
     
  }
  pokerwatchConfigObj['dialogContent'] = dialogContent;
  this.setState({
    pokerwatchConfigObj,
    dialogContent
  })
}
  verifyUserEmailOrAccountName = () => {
      const {pokerwatchConfigObj} = this.state;
      const {creatTeamObj,enableUserProp} = pokerwatchConfigObj;
      if(enableUserProp && creatTeamObj.email===enableUserProp.row.email) {
        delete creatTeamObj.email
      }
      else if(enableUserProp && creatTeamObj.fullName===enableUserProp.row.accountName) {
        delete creatTeamObj.fullName
      }
      apiService(baseUrl + '/pokerWatch/verifyUserEmailOrAccount',
        creatTeamObj, (data) => { 
          pokerwatchConfigObj['errorOBj']={...data}
          this.setState(pokerwatchConfigObj)
        }, (err) => {
          console.log(err);
        })
  }
  handleRoleChange = (event) => {
    const { pokerwatchConfigObj } = this.state;
    let {creatTeamObj} = pokerwatchConfigObj || {};
    creatTeamObj['roleValue'] = event.target.value;
    pokerwatchConfigObj['creatTeamObj']=creatTeamObj;
    this.setState({
      pokerwatchConfigObj
    })
    this.verifyRequiredParamsForDialog()
  }
  handleInputChange = (e, dataType) => {
    const { pokerwatchConfigObj } = this.state;
    pokerwatchConfigObj['creatTeamObj'] = { ...pokerwatchConfigObj['creatTeamObj'], ...dataType.inputObj };
    let dialogBoxType = pokerwatchConfigObj['dialogContent']['dataType']
    if (dataType.type === 'editUser' || dataType.type==='createUser' || (dataType.type !=='team' && !e.target.value) || e.target.value.length < 2
     || dataType.type == 'password') {
      
     if( dataType.type == 'password')
        pokerwatchConfigObj['creatTeamObj'] = { ...pokerwatchConfigObj['creatTeamObj'], ...dataType.inputObj };
      if(dialogBoxType === 'createTeamModal') {
        this.verifyRequiredParamsForDialog('custom')
      }
      else {
      this.verifyRequiredParamsForDialog()
      }
      pokerwatchConfigObj['ownerNameData'] = [];
      pokerwatchConfigObj['teamNameData'] = [];
      this.setState({
        pokerwatchConfigObj
      })
     
      return;
    }
    else {
      let query = dataType.inputObj;
      const endPoint = dataType && dataType.type == 'ownerDetails' ? '/pokerWatch/getOwnersList' : '/pokerWatch/getTeamNames';
      apiService(baseUrl + endPoint,
        query, (data) => {

          if (dataType && dataType.type == 'ownerDetails') {
            pokerwatchConfigObj['ownerNameData'] = data && data.result?data.result:data
            pokerwatchConfigObj['action'] = this.addInputObject;
            pokerwatchConfigObj['errorOBj']={...data}
          }
          else {
            pokerwatchConfigObj['teamNameData'] = data && data.result?data.result:data;
          }
          if(dialogBoxType === 'createTeamModal') {
            this.verifyRequiredParamsForDialog('custom')
          }
          else {
          this.verifyRequiredParamsForDialog()
          }
          this.setState({
            pokerwatchConfigObj,
            teamNameData: data,
            loading: false,
          })
        }, (err) => {
          console.log(err);
        })
      this.setState({
        query,
        searchFunc: true
      })
    }
  }
  getEvDollor = (item) => {
    if (isNaN(item.profitOrLoss) || isNaN(item.ev)) {
      return 0;
    }
    let evDollor = this.NumberFormatter(item.profitOrLoss - item.ev);
    return evDollor;
  }
  removeSearchFun = (event, status) => {
    this.setState({
      searchFunc: status
    })
  }

  handleSelect = (teamName) => {
   
    apiService(baseUrl + '/pokerWatch/getTeamList',
      {
        orderBy: this.state.sortBy,
        sortOn: this.state.sortOn,
        name: teamName
      }
      ,
      (data) => {
        const {pokerwatchConfigObj} = this.state;
       pokerwatchConfigObj['teamData']=data && data[0]?data[0].teamList:{};
         this.setState({
           data: data,
           pokerwatchConfigObj,
    
         })
       
      }, (err) => {

        console.log(err);
      })
  }
  handleUserDirectory = () => {
    const {pokerwatchConfigObj} = this.state;
    let {userDirectory,enableUserDirectory} = pokerwatchConfigObj;
    if(enableUserDirectory) {
      this.callApi(this.state.sortOn, this.state.sortBy);
    }
    else {
      this.getUserDiretory();
    }
    pokerwatchConfigObj['enableUserDirectory'] = !enableUserDirectory;
    pokerwatchConfigObj['userDirectory'] = !userDirectory;
    pokerwatchConfigObj['selectedTeams'] = [];
    this.setState({
      pokerwatchConfigObj
    })
    
  }
  toggleUserDirectory = () =>{
    const {pokerwatchConfigObj} = this.state;
    let userDirectory = pokerwatchConfigObj['userDirectory'];
    pokerwatchConfigObj['userDirectory'] = !userDirectory;
  
    let enableUserProp = pokerwatchConfigObj['enableUserProp'] || {};
   
    if (enableUserProp &&  enableUserProp.status) {
      enableUserProp['status'] = false;
      enableUserProp['row'] = {};
      enableUserProp['index'] = -1;
      enableUserProp['component'] = null;
      pokerwatchConfigObj['enableUserProp'] = enableUserProp;
    }
    this.setState({
      pokerwatchConfigObj
    })

  }
  render() {
    const {pokerwatchConfigObj} = this.state;
    const {enableUserDirectory,dialogContent,errorOBj,enableUserProp} = pokerwatchConfigObj;
    const modalContent =(dialogContent ? dialogContent.dataType == 'createTeamModal' ? <CreateTeam {...this.state.pokerwatchConfigObj} /> : dialogContent.dataType === 'ownerCreationModal'
      ? <CreateOwner {...this.state.pokerwatchConfigObj} /> :
      dialogContent.dataType === 'createUser' ? <CreateUser {...this.state.pokerwatchConfigObj} /> :
        dialogContent.dataType === 'changeRole' ? <ChangeRole {...this.state.pokerwatchConfigObj} /> :
          dialogContent.dataType === 'viewHistory' ? <LoginTrackingHistory {...this.state.pokerwatchConfigObj} /> :
            dialogContent.dataType === 'deleteUser' ? <p className="pokerwatch-dialog-common"> Would you like to delete selected users from the user directory ?</p> :
              dialogContent.dataType === 'editUser' ? <EditUser {...this.state.pokerwatchConfigObj} /> : dialogContent.dataType == 'deleteTeamModal' ? <p className="pokerwatch-dialog-common">Would you like to delete selected stable(s) ?</p> : '':'');
    return (
      <div>
       {this.state.loading ? <Loading backgroundColor={'transparent'} /> : null}
        {Object.keys(this.state.pokerwatchConfigObj).length > 0 ? <PokerWatchAdmin {...this.state.pokerwatchConfigObj} /> : ''}
        {dialogContent && dialogContent.isDialogOpen  ?
           window.innerWidth<=1024 && enableUserProp && enableUserProp.status ? <CustomMobileModal {...dialogContent} errorOBj={errorOBj}>
            {modalContent}
          </CustomMobileModal> :
            <CustomisedDialog {...dialogContent} errorOBj={errorOBj}>
              {modalContent}
            </CustomisedDialog> : ''}   
      </div>);
  }
}
const mapStateToProps = state => {
  return {
    pwReplayer: state.pwReplayer
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
    //setReplayerDetails: (data) => dispatch(actions.setReplayerDetails(data))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PokerWatchNew);



/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/Pokerwatch_new.js
 **/